// import FrontGradientMaterial from '../materials/FrontGradientMaterial';
// import { PERSON_THEME_BG_GRADIENT } from '../../../constants/colors';

const THREE = require('three');

/* const formatGradient = (value) => {
    const { colors, ratios } = value;

    const params = {};

    if (colors instanceof Array) {
        const [color0, color1, color2] = colors;

        params.color0 = color0;
        params.color1 = color1;
        params.color2 = color2;
    }

    if (ratios instanceof Array) {
        const [ratio0, ratio1, ratio2] = ratios;

        params.ratio0 = ratio0;
        params.ratio1 = ratio1;
        params.ratio2 = ratio2;
    }

    return params;
}; */

class ObjectTest extends THREE.Mesh {
    constructor(w, h, color = 0xff0000) {
        const geometry = new THREE.PlaneBufferGeometry(w, h);

        // const params = { ...formatGradient(PERSON_THEME_BG_GRADIENT) };
        const material = new THREE.MeshBasicMaterial({ color, side: THREE.DoubleSide });

        super(geometry, material);

        this._material = material;
    }
}

export default ObjectTest;
